module.exports = __webpack_public_path__ + "img/bq-se.6706547a.svg";